import { FC } from 'react';
import * as Switch from '@radix-ui/react-switch';
import { cn, useNextGenUiCookie } from '@fe-learner-common';
import { useConfigContext } from '@fe-core';

interface TagProps {
  className?: string;
  children: string;
}

const Tag: FC<TagProps> = ({ className, children }) => {
  return (
    <span
      className={cn(
        className,
        'rounded bg-positive-500 px-1 text-body-sm font-medium text-neutral-0',
      )}
    >
      {children}
    </span>
  );
};

export const NextGenUiToggle = ({
  isLoading,
  onChange,
  texts,
}: {
  isLoading: boolean;
  onChange?: (enabled: boolean) => void;
  texts: {
    label: string;
    description: string;
    beta: string;
  };
}) => {
  const { config } = useConfigContext();
  const { enabled, enableNextGenUi, disableNextGenUi } = useNextGenUiCookie();

  const handleToggle = () => {
    if (enabled) {
      onChange?.(enabled);
      disableNextGenUi();
    } else {
      enableNextGenUi();
    }
  };

  if (config.webfeatures?.['nextgenui-default']) {
    return null;
  }

  return (
    // eslint-disable-next-line tailwindcss/no-custom-classname
    <div className="next-gen-ui-toggle flex h-10 shrink-0  items-center justify-center bg-prominence-50 px-4 py-1">
      {!isLoading && (
        <form>
          <div className="flex items-center justify-center">
            <Switch.Root
              onCheckedChange={handleToggle}
              checked={enabled}
              className="relative h-[20px] w-[28px] rounded-full bg-neutral-300 outline-offset-2 data-[state=checked]:bg-prominence-500"
              id="next-gen-ui-switch"
            >
              <Switch.Thumb className="block h-[16px] w-[16px] rounded-full bg-neutral-0 transition-transform duration-100 will-change-transform ltr:translate-x-0.5 ltr:data-[state=checked]:translate-x-[10px] rtl:translate-x-[-2px] rtl:data-[state=checked]:translate-x-[-10px]" />
            </Switch.Root>
            <label
              className="flex cursor-pointer items-center leading-none"
              htmlFor="next-gen-ui-switch"
            >
              <p className="ms-2 text-label-lg">{texts.label}</p>
              <p className="ms-2 hidden text-body-md md:block">
                {texts.description}
              </p>
              <Tag className="ms-2">{texts.beta}</Tag>
            </label>
          </div>
        </form>
      )}
    </div>
  );
};
